export default __webpack_public_path__ + "static/media/invoices-feature-4.967a2135.png";